import React, { Component } from 'react'

export default class Title extends Component {
  render() {
    const { text } = this.props
    return (
      <div className="text-start font-bold my-5 text-pentagramma">
        { text }
      </div>
    )
  }
}
